import {
  Stack,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import HelpButton from "../HelpButton";

interface ComprehensiveEvaluationHelpDialogProps {
  iconSx?: SxProps;
}

export default function ComprehensiveEvaluationHelpDialog({
  iconSx,
}: ComprehensiveEvaluationHelpDialogProps) {
  return (
    <HelpButton
      dialogTitle="総合判定"
      dialogProps={{ fullWidth: true }}
      iconSx={iconSx}
    >
      <Typography
        variant="body1"
        sx={{ color: "text.secondary", whiteSpace: "pre-line" }}
      >
        睡眠の長さ・質・リズムおよび睡眠時無呼吸症候群・不眠症への受診おすすめにより総合判定をします。
      </Typography>
      <Stack sx={{ marginTop: "24px" }}>
        <ComprehensiveEvaluationTable />
        <Stack
          sx={{
            marginTop: "8px",
            "& .MuiTypography-root": {
              color: "text.secondary",
              fontSize: "14px",
            },
          }}
        >
          <Typography sx={{ "& sup": { fontSize: "xx-small" } }}>
            ※睡眠に関して治療中の場合は判定の横に
            <sup>※</sup>が付きます。
          </Typography>
          <Typography>
            ※[E判定]は受診勧奨オプションありの場合のみ表示されます。
          </Typography>
          <Typography>※測定データが3日以下の場合は判定不能。</Typography>
        </Stack>
      </Stack>
    </HelpButton>
  );
}

function ComprehensiveEvaluationTable() {
  const records = [
    ["判定", "判定基準"],
    ["A", "測定期間中の睡眠の長さ・質・リズムが全日〇の判定の場合"],
    [
      "B",
      "睡眠の長さ・質・リズムが習慣的に良好だが、一部の日で改善余地がある場合",
    ],
    ["C", "睡眠の長さ・質・リズムのうち1項目が注意の場合"],
    [
      "D",
      "睡眠の長さ・質・リズムのうち2項目以上が注意、もしくは1項目でも警戒の場合",
    ],
    ["E", "睡眠時無呼吸症候群もしくは不眠症の受診をおすすめする場合"],
  ];
  return (
    <TableContainer
      sx={{
        borderRadius: 0,
        "& .MuiTable-root": {
          "& .MuiTableCell-root": {
            borderBottom: "none",
          },
          tableLayout: "fixed",
          border: "1px solid #e0e0e0",
          "& .MuiTableRow-root": {
            "&:first-of-type,&:not(:last-of-type)": {
              borderBottom: "1px solid #e0e0e0",
            },

            "& .MuiTableCell-head": {
              p: "16px 0px",
              "&:first-of-type": {
                width: "80px",
                textAlign: "center",
              },
              "&:not(:first-of-type)": {
                "& .MuiTypography-root": {
                  borderLeft: "1px solid #e0e0e0",
                },
              },
              "& .MuiTypography-root": {
                px: "16px",
              },
            },
            "& .MuiTableCell-body": {
              "&:first-of-type": {
                width: "80px",
                textAlign: "center",
              },
              "&:not(:first-of-type)": {
                borderLeft: "1px solid #e0e0e0",
              },
            },
          },
        },
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            {records[0].map((r, i) => (
              <TableCell key={i}>
                <Typography variant="subtitle2" color="text.primary">
                  {r}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {records.slice(1).map((r, i) => (
            <TableRow key={i}>
              {r.map((c, i) => (
                <TableCell key={i}>
                  <Typography variant="body2" color="text.primary">
                    {c}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
